import bundledArtifacts from "../../../../shared-protos/tenant_view_bundled_artifacts.json";

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isPortableTenantViewId(value) {
    return UUID.test(value || "");
}

export function wireTenantViewIdToPortableId(value) {
    const normalized = String(value).replace(/-/g, "+").replace(/_/g, "/");
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, "=");
    let binary;
    try {
        binary = atob(padded);
    } catch {
        throw new TypeError("tenant view id must be base64");
    }
    if (binary.length !== 16) throw new TypeError("tenant view id must contain 16 bytes");
    const hex = [...binary]
        .map((character) => character.charCodeAt(0).toString(16).padStart(2, "0"))
        .join("");
    return [
        hex.slice(0, 8),
        hex.slice(8, 12),
        hex.slice(12, 16),
        hex.slice(16, 20),
        hex.slice(20),
    ].join("-");
}

export function portableTenantViewIdToWireId(value) {
    if (!isPortableTenantViewId(value)) {
        throw new TypeError("portable tenant view id must be a UUID");
    }
    const hex = value.replace(/-/g, "");
    const bytes = new Uint8Array(16);
    for (let index = 0; index < bytes.length; index += 1) {
        bytes[index] = Number.parseInt(hex.slice(index * 2, index * 2 + 2), 16);
    }
    let binary = "";
    for (const byte of bytes) binary += String.fromCharCode(byte);
    return btoa(binary);
}

export const BUILTIN_KERNEL_PORTABLE_IDS = Object.freeze(Object.fromEntries(
    bundledArtifacts.kernels.map(({ command, id }) => [command, id]),
));

export const BUILTIN_CANVAS_PORTABLE_IDS = Object.freeze(Object.fromEntries(
    bundledArtifacts.canvases.map(({ slug, id }) => [slug, id]),
));

export const BUILTIN_KERNEL_IDS = Object.freeze(Object.fromEntries(
    bundledArtifacts.kernels.map(({ command, id }) => [
        command,
        portableTenantViewIdToWireId(id),
    ]),
));

export const BUILTIN_CANVAS_IDS = Object.freeze(Object.fromEntries(
    bundledArtifacts.canvases.map(({ slug, id }) => [
        slug,
        portableTenantViewIdToWireId(id),
    ]),
));
